import Box from '@amzn/meridian/box';
import Column from '@amzn/meridian/column';
import Heading from '@amzn/meridian/heading';
import Text from '@amzn/meridian/text';
import React from 'react';

interface PanelBoxProps {
  heading: string;
  blurb?: string;
  children: React.ReactElement | React.ReactElement[];
}

const PanelBox: React.FC<PanelBoxProps> = ({
  heading,
  blurb,
  children,
}: PanelBoxProps): React.ReactElement => {
  return (
    <Box type='outline'>
      <Column spacingInset='400' spacing='none'>
        <Heading level={3}>{heading}</Heading>
        {blurb ? <Text>{blurb}</Text> : null}
      </Column>
      <Column spacingInset='400'>{children}</Column>
    </Box>
  );
};

export default PanelBox;
